/**
 * The /product/:slug registry lives in @stanza/shared so the crawler snapshot
 * renders the same copy. This module adds the admin CMS draft preview on top.
 */
import { PRODUCT_PAGES } from "@stanza/shared/constants/product-pages";

export { PRODUCT_PAGES };

/** slug -> page, for O(1) lookup by the route. */
const PAGES_BY_SLUG = PRODUCT_PAGES.reduce((map, page) => {
  map[page.slug] = page;
  return map;
}, {});

/** localStorage key for a page's unsaved draft (edited in the /product-admin CMS). */
export const draftKey = (slug) => `productDraft:${slug}`;

/**
 * Resolves a product page by slug. If the CMS dashboard has an unsaved draft for
 * this slug in localStorage, that draft is used so edits preview live before
 * they are committed to this file.
 *
 * @param {string} slug
 * @returns {object | null}
 */
export function getProductPage(slug) {
  try {
    const draft = typeof window !== "undefined" && window.localStorage.getItem(draftKey(slug));
    if (draft) return JSON.parse(draft);
  } catch {
    // malformed draft — fall back to the committed page
  }
  return PAGES_BY_SLUG[slug] || null;
}
